import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {CommentDiscussionIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import styles from './ConvertedToDiscussionEvent.module.css'
import type {ConvertedToDiscussionEventNode} from './issue-viewer-view-query-types'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(ConvertedToDiscussionEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when the timeline pagination fragments leave Relay.
export type ConvertedToDiscussionEventFragment = RelayCompat<
  Pick<ConvertedToDiscussionEventNode, 'actor' | 'createdAt' | 'databaseId' | 'discussion'>
>

type ConvertedToDiscussionEventProps = {
  queryRef: ConvertedToDiscussionEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function ConvertedToDiscussionEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: ConvertedToDiscussionEventProps): React.ReactElement {
  const {actor, createdAt, discussion, databaseId} = queryRef

  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={CommentDiscussionIcon}
    >
      <TimelineRow.Main>
        {LABELS.timeline.convertedToDiscussion}
        {discussion && (
          <Link
            href={`${discussion.url}`}
            aria-label={`Discussion #${discussion.number}`}
            inline
            className={styles.discussionLink}
          >
            {` #${discussion.number} `}
          </Link>
        )}
      </TimelineRow.Main>
    </TimelineRow>
  )
}
